// src/components/Navbar.js
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/logo.png';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      {/* Left: Logo + Links */}
      <div className="nav-left">
        <NavLink to="/" className="nav-logo" onClick={() => setMenuOpen(false)}>
          <img src={logo} alt="Talyfax Logo" className="logo-img" />
        </NavLink>
        <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
          <NavLink to="/about" onClick={() => setMenuOpen(false)}>About Us</NavLink>
          <NavLink to="/offerings" onClick={() => setMenuOpen(false)}>Products & Services</NavLink>
          {/* <NavLink to="/portfolio" onClick={() => setMenuOpen(false)}>Portfolio</NavLink>
          <NavLink to="/blogs" onClick={() => setMenuOpen(false)}>Blog</NavLink> */}
          <NavLink to="/careers" onClick={() => setMenuOpen(false)}>Careers</NavLink>
          <NavLink to="/why-talyfax" onClick={() => setMenuOpen(false)}>Why Talyfax</NavLink>
        </div>
      </div>

      {/* Right: CTA + Mobile Toggle */}
      <div className="nav-right">
        <NavLink to="/contact" className="nav-btn nav-contact" onClick={() => setMenuOpen(false)}>
          Get in Touch
        </NavLink>
        <button className="nav-toggle" onClick={() => setMenuOpen(!menuOpen)}>☰</button>
      </div>
    </nav>
  );
}
